
import { Component, Prop,Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import { DateTime } from 'luxon'
import { EventData, EventExtendedProps } from '@/common-datatypes'
import TemplateMembers from '@/components/TemplateMembers.vue'

@Component({
  components: {
    TemplateMembers
  }
})

export default class EventDetails extends Mixins(Common) {
  @Prop({type: Object, default: {}}) private theEventData?: EventData

  get dateTime(){
    if(! this.theEventData || ! this.theEventData.start || ! this.theEventData.end){
      return ''
    }

    // start と end で日付が違うかどうか
    const timeZone = this.theEventData.timeZone

    const start = DateTime.fromJSDate(this.theEventData.start).setZone(timeZone)
    const end = DateTime.fromJSDate(this.theEventData.end).setZone(timeZone)

    const isSameTime = (start == end ? true : false)

    const isSameday = start.startOf('day').diff(end.startOf('day')).milliseconds === 0 ? true : false

    if(isSameTime){
      return this.$dateTimeFormat(start,'DDDD T (ZZZZ)',timeZone)
    }

    let dateTime = this.$dateTimeFormat(start,'DDDD T',timeZone) + ' – '
    if(isSameday){
      dateTime += this.$dateTimeFormat(end,'T (ZZZZ)',timeZone)
    }else{
      dateTime += this.$dateTimeFormat(end,'DDDD T (ZZZZ)',timeZone)
    }
    return dateTime
  }

  get exProps(): EventExtendedProps{
    return this.theEventData?.extendedProps || {} as EventExtendedProps
  }

  get title(){
    return this.theEventData?.title || ''
  }

  get note(){
    const note = this.theEventData?.extendedProps?.note || ''
    return this.$autoLink(this.$stripTags(note))
  }

  async created(){
    //
  }

  mounted(){
    //
  }

  destroyed() {
    console.trace('destroyed');
  }
}
